import { render, staticRenderFns } from "./ZoneSegmentsAmountUI.vue?vue&type=template&id=7ac0c43a&scoped=true&"
import script from "./ZoneSegmentsAmountUI.vue?vue&type=script&lang=ts&"
export * from "./ZoneSegmentsAmountUI.vue?vue&type=script&lang=ts&"
import style0 from "./ZoneSegmentsAmountUI.vue?vue&type=style&index=0&id=7ac0c43a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0c43a",
  null
  
)

export default component.exports